import React from "react";

import PageContent from "../PageContent";
import RoundIcon from "../RoundIcon";
import Icon from "../Icon";
import "./style.css";

function PageApproved() {
  return (
    <PageContent>
      <header />
      <h1>Approved</h1>

      <div className="panel bg-green flex-row">
        <RoundIcon color="blue">
          <Icon name="Ok" color="white" />
        </RoundIcon>
        <div className="panel-content">
          <p>
            Congratulations, your application has been successful. You can now
            login to your bank account:
          </p>
        </div>
      </div>

      <button className="btn white button-go-to-login">Go to login</button>
    </PageContent>
  );
}

export default PageApproved;
